import {TextFilter} from './TextFilter';
import {ChoiceFilter, Option} from './ChoiceFilter';

import {FilterInterface} from './FilterInterface';
import {AbstractFilter} from './AbstractFilter';
import {ArrayCollection} from '@app/lib/base/collection';
import { DateTimeFilter } from './DateTimeFilter';


export class Filters implements Iterable<FilterInterface> {
    private readonly _filters: ArrayCollection<FilterInterface>;

    constructor(filters: ArrayCollection<FilterInterface> = new ArrayCollection<FilterInterface>()) {
        this._filters = filters;
    }

    public addFilterByIdentity(identity: string, ...args): void {
        const filter = this.findFilterByIdentity(identity);
        if (!filter) {
            return;
        }
        if (filter instanceof ChoiceFilter) {
            for (const optionId of args) {
                const option = filter.options.find((opt: Option) => opt.id === optionId);
                if (!option) {
                    continue;
                }

                filter.value.toggle(option);
            }
        }
    }

    public findFilterByIdentity(identity: string): FilterInterface|null {
        for (const filter of this._filters) {
            if (filter.id === identity) {
                return filter;
            }
        }

        return null;
    }

    notEmpty(): boolean {
        for (const filter of this._filters) {
            if (filter.hasValue()) {
                return true;
            }
        }

        return false;
    }

    countActive(): number {
        let n = 0;
        for (const filter of this._filters) {
            n += filter.value.countValues();
        }

        return n;
    }

    reset(): void {
        for (const filter of this._filters) {
            filter.reset();
        }
    }

    get length(): number {
        return this._filters.length;
    }

    [Symbol.iterator](): Iterator<FilterInterface> {
        let index = 0;
        return {
            next: () => {
                const _index = index++;
                return {
                    done: _index >= this._filters.length,
                    value: this._filters[_index]
                }
            }
        }
    }
}

export {TextFilter, ChoiceFilter, Option, AbstractFilter, FilterInterface, DateTimeFilter};
